export const faqItems = [
  {
    id: '1',
    question: 'How does memory embedding work?',
    answer: 'We use OpenAI\'s ada-003 embeddings (or Cloudflare Workers AI) to convert each memory into a high-dimensional vector. At query time, we embed your search query and use cosine similarity to find the most relevant memories. All embedding computation happens server-side — no API key management needed.',
  },
  {
    id: '2',
    question: 'What backends are supported?',
    answer: 'Agent Memory Gateway supports Redis, SQLite, S3-compatible storage, and Postgres (with pgvector). Our hosted tier uses Cloudflare R2 + D1 by default. Self-hosted tiers let you bring your own backend, giving you complete data sovereignty.',
  },
  {
    id: '3',
    question: 'How is cross-provider transfer implemented?',
    answer: 'When you call agent.recall() with a different provider, the gateway normalizes your memory into our standard schema, which is provider-agnostic. The receiving agent then gets identical context — same conversation history, same tool results, same task progress — makingClaude↔GPT switches seamless.',
  },
  {
    id: '4',
    question: 'What happens if a provider goes down?',
    answer: 'Your memories are stored independently of any provider in our infrastructure. If Anthropic or OpenAI has an outage, your agents retain full memory continuity. We\'re the resilience layer — not dependent on provider uptime.',
  },
  {
    id: '5',
    question: 'How do you handle concurrent writes?',
    answer: 'We implement optimistic locking with version vectors. When multiple agents write to the same memory cluster, each write is timestamped and conflict-resolved using Last-Write-Wins for simple fields, and merge strategies for conversation history. Enterprise tiers get configurable conflict resolution policies.',
  },
  {
    id: '6',
    question: 'Is my data encrypted?',
    answer: 'All memories are encrypted at rest using AES-256. In transit, we use TLS 1.3. We\'re SOC 2 Type II certified. Memory content is never shared across customer boundaries — strict tenant isolation. Enterprise customers can also bring their own encryption keys (BYOK).',
  },
];
